import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferAppleMusicToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.transferAppleMusicToSpotify}
            sections={<PairTransferGuideContent sourceKey="appleMusic" destKey="spotify" />}
        />
    );
}
